import {
  GET_CHALLENGEQUESTIONS,
  GET_CHALLENGEQUESTIONS_SUCCESSED,
  GET_CHALLENGEQUESTIONS_FAILED,
} from '../actions/actionTypes'

const initialState = {
  data: {},
  requesting_get: false,
  requesting_get_successful: false,
  message: null,
  loading_message: "Loading challenge questions..."
}

function challengeQuestionsReducers(state = initialState, action) {
  switch (action.type) {
    case GET_CHALLENGEQUESTIONS:
      return Object.assign({}, {
        requesting_get: true,
        requesting_get_successful: false,
        data: Object.assign({}, state.data),
        message: null,
        loading_message: "Loading challenge questions..."
      })
    case GET_CHALLENGEQUESTIONS_SUCCESSED:
      return Object.assign({}, {
        requesting_get: false,
        requesting_get_successful: true,
        data: Object.assign({}, action.data),
        message: null,
        loading_message: state.loading_message
      })
    case GET_CHALLENGEQUESTIONS_FAILED:
      return Object.assign({}, {
        requesting_get: false,
        requesting_get_successful: false,
        data: Object.assign({}, state.data),
        message: "There was an unexpected error, please refresh the page and try again. If the problem persists, please contact help desk for support.",
        loading_message: state.loading_message
      })

    default:
      return state
  }
}

export default challengeQuestionsReducers;
